
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire11e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire11e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $a74a0847154d0e87$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["Y15zO","index.eca784df.js","i7iDb","kfc.1e06fb6a.png","aSq6Y","california.85a8ce3f.png","iFm3Y","hariSuper.e512c473.png","3McWw","empire.65f03ba6.png","gZP7E","burgerking.3b3a78e7.png","bmzTK","theobroma.578c9f99.png","6j27j","leon.849cdbd5.png","g9xS8","mcdonalds.d240e438.png","71amR","nic.2516afdf.png","aCZZL","ab.348db202.png","99QRa","pizza.38d4345b.png","p6F9Z","subway.04ad0430.png","2lZ72","truffles.85b3b928.png","8WFOZ","wowmomos.2fe32978.png","3IReU","upahara.f5f4acdc.png","fHV84","delivery1.591efc2c.png","5WEXS","subwayfirstdish.d31511be.png","5aNob","subwayseconddish.d39695a5.png","7U0OO","subwaythirddish.8a1c6b61.png","esMdq","subwayfourthdish.493d6dc4.png","7E8Q5","subwayfifthdish.1d95a783.png","kHRg8","mcdfirstdish.9b202a23.png","inuie","mcdseconddish.5eddb256.png","kMvsG","mcdthirddish.99ef0790.png","jLtou","mcdfourthdish.e6ce932e.png","iv46Z","mcdfifthdish.92e14f64.png","1wV6d","califorfirstdish.cf9c93fc.png","bElA4","califorseconddish.601f3e33.png","cdqr4","califorthirddish.d230df07.png","aLHe1","califorfourthdish.601f3e33.png","7FECX","califorfifthdish.cf9c93fc.png","gTaCi","a2bfirstdish.8065b879.png","bjGSy","a2bseconddish.e2be9631.png","kbEAo","a2bthirddish.759a9a17.png","6btSY","a2bfourthdish.0e102276.png","hRDrt","a2bfifthdish.90cf938c.png","2uz8M","theofirstdish.392dc8ac.png","5yXsl","theoseconddish.1ff174c6.png","rJCV3","empirefirstdish.0ee2d8c0.png","cqgmK","empireseconddish.051278b8.png","2Lsbj","pizzagarlicfirstdish.07b4e4aa.png","hCfX4","pizzaseconddish.bd08a20c.png","hQdDx","nicseconddish.4fde9353.png","aN1s3","nicfirstdish.220ce3e9.png","1dH9F","leonseconddish.787393af.png","e4CQY","leonfirstdish.892aa69e.png","itvHO","burgerkfirstdish.826d29ba.png","eI7LI","burgerkseconddish.8f0cb8f8.png","7JWVH","trufflesfirstdish.95d4403b.png","1ed6N","trufflesseconddish.11c776dc.png","hXn06","hssfirstdish.23909184.png","66k8S","hssseconddish.611f959e.png","eYQl1","kfcfirstdish.d40a7b62.png","9EzFP","kfcseconddish.f490e8a6.png","jMyUU","upaharadfirstdish.331ecc00.png","dBSka","upaharaseconddish.9bcc1c5c.png","e2ku7","wowmfirstdish.8d1fffe6.png","lxCex","wowmseconddish.05c07e50.png"]'));


//# sourceMappingURL=index.runtime.0fe1a364.js.map
